import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Tag } from '../shared/models/general/tag';

@Injectable({
  providedIn: 'root',
})
export class TagsService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/tags/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  private _refreshNeeded$ = new Subject<number>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  public GetAllTags(): Observable<Tag[]> {
    return this.http.get<Tag[]>(`${this.apiUrl}`);
  }

  public GetNonSystemTags(): Observable<Tag[]> {
    return this.http.get<Tag[]>(`${this.apiUrl}non-system`);
  }

  public GetUserTags(userId: number, active: boolean): Observable<Tag[]> {
    return this.http.get<Tag[]>(`${this.apiUrl}${userId}/${active}`);
  }

  public UpsertUserTags(tag: Tag): Observable<Tag> {
    return this.http
      .post<Tag>(`${this.apiUrl}upsert`, tag, {
        observe: 'response',
      })
      .pipe(
        map((res) => {
          if (res) {
            if (res.status == 200) {
              return new Tag().deserialize(res.body);
            }
          }
        }),
        tap(() => {
          this._refreshNeeded$.next(tag.userId);
        })
      );
  }
}
